import { render, staticRenderFns } from "./WishList.vue?vue&type=template&id=600e9698&scoped=true"
import script from "./WishList.vue?vue&type=script&lang=js"
export * from "./WishList.vue?vue&type=script&lang=js"
import style0 from "./WishList.vue?vue&type=style&index=0&id=600e9698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600e9698",
  null
  
)

export default component.exports